export type CyanTakeoverIntent =
  | {
      type: "NONE";
    }
  | {
      type: "PREPARE";

      objective: string;
    }
  | {
      type: "ACTIVATE";
    }
  | {
      type: "REFRESH";
    }
  | {
      type: "APPEND";

      objective: string;
    };

function normalized(value: string) {
  return value.trim().toLowerCase();
}

export function detectCyanTakeoverIntent(message: string): CyanTakeoverIntent {
  const text = normalized(message);

  if (!text) {
    return {
      type: "NONE",
    };
  }

  const prepareSignals = [
    "analyze this project",
    "analyse this project",
    "analyze the project",
    "analyse the project",
    "diagnose this project",
    "diagnose the project",
    "prepare takeover",
    "prepare everything",
    "analyze everything",
    "analyse everything",
    "analise este projeto",
    "analise o projeto",
    "diagnostique este projeto",
    "prepare tudo",
    "prepare o takeover",
  ];

  if (prepareSignals.some((signal) => text.includes(signal))) {
    return {
      type: "PREPARE",

      objective: message.trim(),
    };
  }

  const activateSignals = [
    "execute the plan",
    "start execution",
    "activate takeover",
    "go ahead",
    "you can execute",
    "pode executar",
    "pode comecar",
    "pode começar",
    "execute o plano",
    "inicie a execucao",
    "inicie a execução",
  ];

  if (activateSignals.some((signal) => text.includes(signal))) {
    return {
      type: "ACTIVATE",
    };
  }

  const refreshSignals = [
    "update status",
    "refresh status",
    "show progress",
    "where are we",
    "status do projeto",
    "atualize o status",
    "mostre o progresso",
    "como esta o projeto",
    "como está o projeto",
  ];

  if (refreshSignals.some((signal) => text.includes(signal))) {
    return {
      type: "REFRESH",
    };
  }

  const appendSignals = [
    "add this to the queue",
    "add to the queue",
    "add this idea",
    "include this too",
    "adicione isso a fila",
    "adicione isso à fila",
    "adicione esta ideia",
    "inclua isso tambem",
    "inclua isso também",
  ];

  if (appendSignals.some((signal) => text.includes(signal))) {
    return {
      type: "APPEND",

      objective: message.trim(),
    };
  }

  return {
    type: "NONE",
  };
}

/**
 * Natural owner confirmations are activation signals only when the
 * caller has already established an activatable prepared operational
 * session. This helper MUST NOT be used as a global intent detector.
 */
export function isCyanOwnerActivationConfirmation(
  message: string,
): boolean {
  const normalized = message
    .trim()
    .toLocaleLowerCase()
    .replace(/[.!?]+$/g, "")
    .trim();

  const exactConfirmations = new Set([
    "yes",
    "yes proceed",
    "yes, proceed",
    "proceed",
    "execute",
    "go ahead",
    "confirm",
    "confirmed",
    "approved",
    "sim",
    "sim pode executar",
    "sim, pode executar",
    "pode executar",
    "pode prosseguir",
    "confirme",
    "confirmado",
    "aprovado",
  ]);

  return exactConfirmations.has(normalized);
}

